import React from 'react'
import { Form, Input, Select, InputNumber, Button } from 'antd'
import PropTypes from 'prop-types'
import { DeleteOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { EnFormItem } from '../shared/LocalizedFields'

const { TextArea } = Input

const StyledDivDelete = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const CartoonSeriesForm = ({
  form,
  id,
  seriesName,
  descriptionKZ,
  descriptionRU,
  descriptionEN,
  year,
  country,
  status,
  index,
  seasons,
  setCoverImageFile,
  coverImageFileRef,
  allVideoPlaylists,
  removeFilesHandler
}) => {
  const FormItem = Form.Item

  return (
    <Form form={form} layout="vertical" hideRequiredMark>
      <div style={{ marginBottom: '3%' }}>
        <>Обложка серии</>
        <StyledDivDelete>
          <input
            type="file"
            accept="image/*"
            ref={coverImageFileRef}
            onChange={event => setCoverImageFile(event.target.files[0])}
          />
          {id && (
            <Button
              danger
              onClick={() => {
                removeFilesHandler(id)
              }}
            >
              <DeleteOutlined />
            </Button>
          )}
        </StyledDivDelete>
      </div>

      <FormItem
        key="seriesName"
        label="Название серии"
        name="seriesName"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название серии`
          }
        ]}
        initialValue={seriesName}
      >
        <Input placeholder="Название серии" />
      </FormItem>

      <FormItem
        key="descriptionKZ"
        label="Описание на казахском"
        name="descriptionKZ"
        initialValue={descriptionKZ}
      >
        <TextArea placeholder="Описание серии на казахском языке" rows={3} />
      </FormItem>

      <FormItem
        key="descriptionRU"
        label="Описание на русском"
        name="descriptionRU"
        initialValue={descriptionRU}
      >
        <TextArea placeholder="Описание серии на русском языке" rows={3} />
      </FormItem>
      <EnFormItem
        name="descriptionEN"
        label="Описание на английском"
        initialValue={descriptionEN}
        multiline
      />

      <FormItem
        key="year"
        label="Год выпуска"
        name="year"
        initialValue={year}
      >
        <InputNumber
          min={1900}
          max={2030}
          placeholder="Год выпуска серии"
          style={{ width: '100%' }}
        />
      </FormItem>

      <FormItem
        key="country"
        label="Страна"
        name="country"
        initialValue={country}
      >
        <Input placeholder="Страна производства" />
      </FormItem>

      <FormItem
        key="status"
        label="Статус"
        name="status"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите статус`
          }
        ]}
        initialValue={status}
      >
        <Select placeholder="Выберите" mode="single">
          <Select.Option key="active" value="active">
            Активный
          </Select.Option>
          <Select.Option key="inactive" value="inactive">
            Скрытый
          </Select.Option>
        </Select>
      </FormItem>

      <FormItem
        key="index"
        label="Очередность отображения"
        name="index"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите очередность`
          }
        ]}
        initialValue={index}
      >
        <InputNumber min={1} placeholder="Очередность" />
      </FormItem>

      <FormItem
        key="seasons"
        label="Сезоны (VideoPlaylist)"
        name="seasons"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите сезоны`
          }
        ]}
        initialValue={seasons?.map(item => (item ? item?.id : item)) || []}
      >
        <Select
          placeholder="Выберите сезоны"
          mode="multiple"
          allowClear
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {allVideoPlaylists?.statusedCartoons?.map(videoPlaylist => (
            <Select.Option key={videoPlaylist.id} value={videoPlaylist.id}>
              {videoPlaylist.title}
            </Select.Option>
          ))}
        </Select>
      </FormItem>
    </Form>
  )
}

CartoonSeriesForm.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  seriesName: PropTypes.string
}

CartoonSeriesForm.defaultProps = {
  seriesName: '',
  descriptionKZ: '',
  descriptionRU: '',
  descriptionEN: '',
  year: null,
  country: '',
  seasons: [],
  index: null,
  status: 'active'
}

export default CartoonSeriesForm